// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2V1-M","header":"ReportDetails_header__ynfK-","title":"ReportDetails_title__h4JA3","left":"ReportDetails_left__7_V2I"};